import React, { memo, ChangeEvent } from 'react'
import { RadioOption } from 'transfix-ui/components/RadioOption'
import { SUBSCRIBER_NOTIFICATION_TYPE } from 'apps/fleet-planner/constants/loads'

interface ISubscriberSettingsModalTextProps {
  notifySubscribersOption: SUBSCRIBER_NOTIFICATION_TYPE
  onChange: (newOptionValue: string) => void
}

const ACTIVE_STATUS_LABEL = 'Just tracking updates'
const ACTIVE_STATUS_TEXT =
  'People will be notified when your load’s status is updated to Dispatched, In Transit, At Pickup, At Dropoff, Loading, Unloading, or Delivered.'
const ALL_STATUSES_LABEL = 'Every status update'
const ALL_STATUSES_TEXT = 'Subscribers will be notified whenever your load’s status is updated.'

export const SubscriberSettingsModalText = memo<ISubscriberSettingsModalTextProps>(
  ({ notifySubscribersOption, onChange }) => {
    const selectOptionHandler = (e: ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value)
    }

    return (
      <div>
        <div className='body-medium pt3 pb3'>Notify people about</div>
        <RadioOption
          name='subscriber-settings'
          id={SUBSCRIBER_NOTIFICATION_TYPE.ACTIVE_STATUSES}
          value={SUBSCRIBER_NOTIFICATION_TYPE.ACTIVE_STATUSES}
          selected={notifySubscribersOption === SUBSCRIBER_NOTIFICATION_TYPE.ACTIVE_STATUSES}
          onChange={selectOptionHandler}>
          <div>
            <span className='b'>{ACTIVE_STATUS_LABEL}</span>
            <p>{ACTIVE_STATUS_TEXT}</p>
          </div>
        </RadioOption>

        <RadioOption
          name='subscriber-settings'
          id={SUBSCRIBER_NOTIFICATION_TYPE.ALL_STATUSES}
          value={SUBSCRIBER_NOTIFICATION_TYPE.ALL_STATUSES}
          selected={notifySubscribersOption === SUBSCRIBER_NOTIFICATION_TYPE.ALL_STATUSES}
          onChange={selectOptionHandler}>
          <div>
            <span className='b'>{ALL_STATUSES_LABEL}</span>
            <p>{ALL_STATUSES_TEXT}</p>
          </div>
        </RadioOption>
      </div>
    )
  }
)
